<template>
  <Modal v-model="modal" :closable="false" :mask-closable="false" title="玩法连动管理" width="400">
    <div>
      <table class="lida-leading-table" width="100%">
        <tr>
          <th width="40%">玩法</th>
          <th class="pa-1">
            <span>连动</span>
            <Button class="mx-1" type="primary" @click="ModifyAll(1)">开启</Button>
            <Button type="error" @click="ModifyAll(0)">关闭</Button>
          </th>
        </tr>
        <tr v-for="it in items" :key="it.pmid">
          <td>{{it.pmname}}</td>
          <td>
            <RadioGroup v-model="it.linkodds">
              <Radio :label="1">开启</Radio>
              <Radio :label="0">关闭</Radio>
            </RadioGroup>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer">
      <Button type="primary" @click="modal = false">取消</Button>
      <Button type="error" @click="postData">修改</Button>
    </div>
  </Modal>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'GameGearing',
  data () {
    return {
      mid: null,
      gameid: null,
      modal: false,
      items: [],
      modify: []
    }
  },
  computed: {
    ...mapGetters(['getmember', 'getgameid'])
  },
  watch: {
    modal (val) {
      let tiemr
      if (!val) {
        tiemr = setTimeout(() => {
          this.modify = []
          this.items = []
          this.mid = null
          this.gameid = null
        }, 300)
      } else {
        clearTimeout(tiemr)
      }
    }
  },
  methods: {
    async getlist (gameid, id) {
      this.mid = id
      this.gameid = gameid
      this.modal = true
      try {
        const res = await this.$axios.acount.accms(gameid, id)
        if ('status' in res && res.status === 0) return
        if (!res.data) return
        this.items = res.data.map(it => (it.defaultOdds = it.linkodds, it))
      } catch (error) {
        console.log(error);
      }
    },
    modifyArray () {
      return this.items
        .filter(it => it.defaultOdds != it.linkodds)
        .map(it => {
          return {
            pmid: it.pmid,
            linkodds: it.linkodds,
            gameid: Number(this.gameid),
          }
        })
    },
    ModifyAll (state) {
      this.items.forEach(it => {
        it.linkodds = state
      })
    },
    async postData () {
      this.modify = this.modifyArray()
      if (!this.modify.length) return
      try {
        const obj = {
          loid: this.getmember.pid,
          mid: Number(this.mid),
          itemslinkodds: this.modify
        }
        const res = await this.$axios.acount.memlinkoddsupd(obj)
        if (res.status === 1) {
          this.$Message.success("已更改");
          this.modal = false;
          this.mid = null
          this.gameid = null
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}
</script>